import { render, staticRenderFns } from "./TextShadowProperties.vue?vue&type=template&id=9b76bfd4&scoped=true"
import script from "./TextShadowProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextShadowProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextShadowProperties.vue?vue&type=style&index=0&id=9b76bfd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b76bfd4",
  null
  
)

export default component.exports